var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { MainImage } from "./main";
import { Thumbnail } from "./thumbnail";
var CarouselWrapper = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var ThumbnailWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(5, 50px);\n  grid-gap: 0.5rem;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(5, 50px);\n  grid-gap: 0.5rem;\n"])));
var Carousel = function (_a) {
    var images = _a.images;
    var _b = useState(images[Object.keys(images)[0]]), main = _b[0], setMain = _b[1];
    var handleClickThumbnail = useCallback(function (e) {
        var key = e.currentTarget.dataset.key;
        if (key) {
            setMain(images[key]);
        }
    }, []);
    var thumbnails = useMemo(function () {
        return Object.entries(images).map(function (_a) {
            var key = _a[0], src = _a[1];
            return (React.createElement(Thumbnail, { key: key, id: key, src: src, isActive: images[key] === main, onClick: handleClickThumbnail }));
        });
    }, [images, main]);
    return (React.createElement(CarouselWrapper, null,
        React.createElement(MainImage, { src: main }),
        React.createElement(ThumbnailWrapper, null, thumbnails)));
};
export default Carousel;
var templateObject_1, templateObject_2;
